import { useEffect, useState } from 'react';
import { useAppSelector } from 'reducers/hooks'
import spritemap from "@milestone-sys/web-design-system/msds-spritemap.svg"
import { ReactComponent as MilestoneLogo } from '../../../components/Header/milestone-pdf-logo.svg'
import { IProps } from '../../../lib/types'
import './print.scss'

const ProposalsHeaderPdf = ({ proposals }: IProps) => {

    const [proposalCalculationData, setProposalCalculationData] = useState(proposals?.calculationData?.data);    
    useEffect(() => {
        if (proposals) {
            setProposalCalculationData(proposals.calculationData?.data);            
        }
    }, [proposals]);
    
    //Get the user information
    const userData = useAppSelector(state => state.user.userData)

    //Get a formatted date
    const getDate = (): string => {
        const date = new Date(proposalCalculationData?.siteDesignDateUtc)
        const [month, day, year] = [date.toLocaleString('default', { month: 'long' }), date.getDate(), date.getFullYear()]
        return `${month} ${day}, ${year}`
    }

    return (
        <div className='xsd-proposals-pdf msds-bg-clear-blue msds-text-white container-fluid px-10 py-8'>
            <div className='row'>
                <div className="col-12 pb-2 xsd-proposals-pdf__milestone-logo-container">
                    <MilestoneLogo className="xsd-proposals-pdf__milestone-logo" />
                </div>
                <div className="col-8 msds-text-header-3 pb-2">Proposal</div>
                <div className="col-4 msds-text-header-4 pb-4">Integrator details</div>

                <div className="col-4">
                    <div className="msds-text-body-1">Configuration Date:</div>
                    <div className="msds-text-body-1">Project name: </div>
                    <div className="msds-text-body-1">Site:</div>
                    <div className="msds-text-body-1">Site design:</div>
                    <div className="msds-text-body-1">Product:</div>
                </div>
                <div className="col-4 d-flex flex-column ">
                    <div className="msds-text-body-1 text-end">{getDate()}</div>
                    <div className="msds-text-body-1 text-end">{proposalCalculationData?.projectName}</div>
                    <div className="msds-text-body-1 text-end">{proposalCalculationData?.siteName}</div>
                    <div className="msds-text-body-1 text-end">{proposalCalculationData?.siteDesignName}</div>
                    <div className="msds-text-body-1 text-end">{proposalCalculationData?.xProtectPlatform}</div>
                </div>
                <div className="col-4">
                    <div className="msds-text-body-1">{userData.name} {userData.lastName}</div>
                    <div className="msds-text-body-1 pb-4">{userData.companyName}</div>
                    <div>
                        {userData.email &&
                            <div className="xsd-proposals-pdf__contact msds-text-body-1 d-flex" >
                                <svg className="mr-4">
                                    <use href={`${spritemap}#email`} />
                                </svg>
                                {userData.email}
                            </div>
                        }
                        {userData.phone &&
                            <div className="xsd-proposals-pdf__contact msds-text-body-1 d-flex" >
                                <svg className="mr-4">
                                    <use href={`${spritemap}#phone`} />
                                </svg>
                                {userData.phone}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProposalsHeaderPdf
